import React from "react";
import PropTypes from "prop-types";
import Rainbow from "assets/img/spinner-rainbow.svg";
import Black from "assets/img/spinner_black.svg";
import Gear from "assets/img/spinner_gear.svg";
import "./style.css";

export function SpinnerRainbow(props) {
  return (
    <div className="center">
      <img style={{ ...props }} src={Rainbow} alt="Loading...." />
    </div>
  );
}

export function SpinnerBlack(props) {
  return (
    <div className={"center " + props.className}>
      <img style={{ ...props }} src={Black} alt="Loading...." />{" "}
    </div>
  );
}

export function SpinnerSyncBlock() {
  return (
    <div className="loading-async-block">
      <span className="mr-10">Loading...</span>{" "}
      <img width="75" src={Gear} alt="Loading..." />
    </div>
  );
}

SpinnerRainbow.propTypes = {
  props: PropTypes.object
};
